export const constants = {
  getTransactionDetailsEndPoint: '/pages/sms/ess/v3/ws/rest/pub/ssr/transaction',
  fidoLoggingEndpoint: '/pages/sms/ess/v3/ws/rest/pub/ssr/fidoLogging',
  registrationEncryption : "#egEncryPtionV@|",
  chooseVendors : "/chooseVendors",
  PATHVERIFYPICMOBILE: '/ssr/PIC/verifyUserPIC',
  PATHVERIFYCPCMOBILE: '/ssr/CPC/verifyUserRegcode',
};